var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.833c-4.588 0-8.308-3.73-8.308-8.333 0-4.602 3.72-8.333 8.308-8.333 4.588 0 8.308 3.73 8.308 8.333 0 4.602-3.72 8.333-8.308 8.333zm-.829-5l5.875-5.892-1.175-1.179-4.7 4.714-2.35-2.357-1.174 1.179 3.524 3.535z",
    fill: "#E95832"
  })));
}
export default __webpack_public_path__ + "static/media/CheckIcon.64532498.svg";
export { SvgCheckIcon as ReactComponent };